import React, { Component } from "react";
import { browserHistory } from "react-router";
import firebase from "../firebase";

export default class Connect extends Component {
  componentWillMount() {
    const { location } = this.props;
    const query = location && location.query;

    const state = query && query.state;
    const code = query && query.code;

    if (!code) {
      return browserHistory.push(`/${state}/settings`);
    }

    if(!state) {
        return browserHistory.push(`/`);
    }

    firebase
      .functions()
      .httpsCallable("connectStripeAccount")({ code, restaurantId: state })
      .finally(() => {
        browserHistory.push(`/${state}/settings`);
      });
  }

  render() {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>Connecting...</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Connect.js